import type { ApiResponse, PlannerTaskRelation } from '@vision/ui/interfaces';
import type { PlannerTaskRelationResponseDto } from './task-relations.api.types';
import { fromApiTaskRelation } from './tasks.mappers';

export function fromApiPlannerTaskRelationResponse(
  response: ApiResponse<PlannerTaskRelationResponseDto>,
): ApiResponse<PlannerTaskRelation> {
  return { ...response, data: fromApiTaskRelation(response.data) };
}
